'use client';
import { Flex, Box, omitText, Typography, Coachmark, NotificationDot, CartBadge } from '@kohler-dsm-library/kohler-core';
import { UserIcon, FavoriteNavFilledIcon, FavoriteNavIcon } from '@kohler-dsm-library/kohler-icons';
import clsx from 'clsx';
import React, { useEffect } from 'react';
import { LanguageMenu } from '../LanguageMenu/LanguageMenu.mjs';
import { LoginMenu } from '../LoginMenu/LoginMenu.mjs';
import { StoreMenu } from '../StoreMenu/StoreMenu.mjs';
import { LocationPickButton } from './subcomponents/LocationPickButton/LocationPickButton.mjs';
import { LanguagePicker } from './subcomponents/LanguagePicker/LanguagePicker.mjs';
import classes from './UtilityLinks.module.css.mjs';

const omitFavoritesCTA = (favoritesCTA) => {
  const { isFilled = false, notificationDot, ...omitFavoritesCTA2 } = favoritesCTA;
  return { isFilled, notificationDot, omitFavoritesCTA: omitFavoritesCTA2 };
};
const UtilityLinks = ({
  isLoggedIn = false,
  locationPickerCTA,
  languagePicker,
  favoritesCTA,
  cartBadgeCTA,
  userName,
  userCTA,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  utilityLinksMobile,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  userCTAMobile,
  menuType,
  storeMenu,
  loginMenu,
  languageMenu,
  setMenuType,
  setIsOpenMobileMenu,
  className,
  ...rest
}) => {
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        setMenuType?.(null);
        if (setIsOpenMobileMenu) {
          setIsOpenMobileMenu(false);
        }
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [setMenuType, setIsOpenMobileMenu]);
  return /* @__PURE__ */ React.createElement(Flex, { className: clsx(classes.utilityLinks, className), ...rest }, (locationPickerCTA || languagePicker) && /* @__PURE__ */ React.createElement(Flex, { align: "center", gap: 25, paddingLeft: 25 }, locationPickerCTA && /* @__PURE__ */ React.createElement(
    LocationPickButton,
    {
      "aria-expanded": menuType === "store",
      "aria-controls": "store-menu",
      "aria-activedescendant": menuType === "store" ? "store-menu" : void 0,
      ...locationPickerCTA
    }
  ), menuType && storeMenu && /* @__PURE__ */ React.createElement(Box, { display: menuType !== "store" ? "none" : void 0, className: classes.menuPositionWrapper }, /* @__PURE__ */ React.createElement(StoreMenu, { ...storeMenu, setMenuType, setIsOpenMobileMenu })), languagePicker && /* @__PURE__ */ React.createElement(
    LanguagePicker,
    {
      ...languagePicker,
      languagePickerCTA: {
        "aria-controls": "language-menu",
        "aria-activedescendant": menuType === "language" ? "language-menu" : void 0,
        "aria-expanded": menuType === "language",
        ...languagePicker.languagePickerCTA
      }
    }
  ), menuType && languageMenu && /* @__PURE__ */ React.createElement(Box, { display: menuType !== "language" ? "none" : void 0, className: classes.menuPositionWrapper }, /* @__PURE__ */ React.createElement(LanguageMenu, { ...languageMenu, setMenuType, setIsOpenMobileMenu }))), (locationPickerCTA || languagePicker) && /* @__PURE__ */ React.createElement("div", { className: classes.divider }), /* @__PURE__ */ React.createElement(Flex, { className: classes.utilityLink, gap: 15, align: "center" }, userCTA && /* @__PURE__ */ React.createElement(
    Box,
    {
      component: "button",
      type: "button",
      display: "flex",
      textColor: "var(--content-primary)",
      "aria-label": isLoggedIn ? "user sign in" : "profile",
      "aria-expanded": menuType === "user",
      "aria-controls": "login-menu",
      ...omitText(userCTA)
    },
    isLoggedIn && userName ? /* @__PURE__ */ React.createElement(Typography, { size: "label-medium-xs", textColor: "var(--content-primary)" }, "Hi, ", userName) : /* @__PURE__ */ React.createElement(UserIcon, { withBoundingBox: false })
  ), menuType && loginMenu && /* @__PURE__ */ React.createElement(Box, { display: menuType !== "user" ? "none" : void 0, className: classes.menuPositionWrapper }, /* @__PURE__ */ React.createElement(LoginMenu, { ...loginMenu, setMenuType, setIsOpenMobileMenu })), favoritesCTA && /* @__PURE__ */ React.createElement(
    Coachmark,
    {
      target: /* @__PURE__ */ React.createElement(NotificationDot, { disabled: true, position: "top-end", top: 7, right: 3, withBorder: true, ...favoritesCTA.notificationDot }, /* @__PURE__ */ React.createElement(
        Box,
        {
          component: "a",
          display: "flex",
          "aria-label": "see favorites",
          textColor: "var(--content-primary)",
          ...omitFavoritesCTA(favoritesCTA).omitFavoritesCTA
        },
        omitFavoritesCTA(favoritesCTA).isFilled ? /* @__PURE__ */ React.createElement(FavoriteNavFilledIcon, { withBoundingBox: false }) : /* @__PURE__ */ React.createElement(FavoriteNavIcon, { withBoundingBox: false })
      )),
      disabled: !favoritesCTA.coachmark?.dropdown,
      variant: "highlight",
      size: "small",
      position: "bottom",
      withArrow: true,
      ...favoritesCTA.coachmark
    }
  ), cartBadgeCTA && /* @__PURE__ */ React.createElement(
    CartBadge,
    {
      display: "flex",
      textColor: "var(--content-primary)",
      component: "a",
      "aria-label": "see cart",
      withBoundingBox: false,
      ...cartBadgeCTA
    }
  )));
};

export { UtilityLinks };
